module.exports = __webpack_public_path__ + "static/img/three2_tr.1a0c79b8.png";